<template>
    <div class="section-bg mt-10 mb-4">
        <h4 class="section-label">
            <slot></slot>
        </h4>
    </div>
</template>

<script>
export default {
    name: "SectionLabel"
}
</script>

<style scoped>

</style>
